import { computed, ref } from "vue";
import { useSessionStorage } from "vue-composable";

const available_terms_loading = ref(false);
const available_terms = ref([]);

const { storage: selected_terms } = useSessionStorage('selected_terms', []);
const clear_term_selection = function () {
  selected_terms.value = [];
}
const no_term_selected = computed(()=> !selected_terms.value.length);

export default () => {
  return {
    available_terms_loading,
    available_terms,
    selected_terms,
    clear_term_selection,
    no_term_selected
  }
}
